module.exports = __webpack_public_path__ + "img/Cumulative impact assessment-Mitigation measures.40a78e75.svg";